import { GetTransactionData } from "../api/services/transaction";
import { toast } from "react-toastify";

export function useTransaction()  {
    
    const getTransactions = async () => {

        const response = await GetTransactionData();
        console.log('response', response)
        const { message, status, errors } = response;
        if (status === 200) {
            message && toast["success"](message);
          
        } else {
            message && toast["error"](message);
        }
    
        return response;
      };

      return {
        getTransactions
      }
}